import { Box } from "@mui/material";

import SelectedSlot from "./assets/selectedSlot.svg";
import UnselectedSlot from "./assets/unselectedSlot.svg";

export const DashboardSlotSelect = ({
  isSelected,
  size,
}: {
  isSelected: boolean;
  size: "small" | "medium" | "large";
}) => {
  return (
    <Box
      sx={{
        width: size === "small" ? 20 : size === "medium" ? 24 : 32,
        height: size === "small" ? 20 : size === "medium" ? 24 : 32,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isSelected ? <SelectedSlot /> : <UnselectedSlot />}
    </Box>
  );
};
